import { render, staticRenderFns } from "./listsAdd.vue?vue&type=template&id=44850989&"
import script from "./listsAdd.vue?vue&type=script&lang=ts&"
export * from "./listsAdd.vue?vue&type=script&lang=ts&"
import style0 from "./listsAdd.vue?vue&type=style&index=0&id=44850989&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports